import React, { useMemo, useRef, useState } from "react";
import classnames from "classnames";
import "./styles.less";
import { Drawer } from "../Drawer";

export const MobileSelect = (props) => {
  const { options = [], onChange, value, name, className, style } = props;

  // const [visible, setVisible] = useState(false);

  const currLabel = useMemo(() => {
    return options.find((item) => item.value === value)?.label;
  }, [options, value]);

  return (
    <>
      <div
        style={{ ...style }}
        className={classnames("authing-mobile-select", className)}
      >
        <select
          onChange={onChange}
          className="authing-mobile-select"
          name={name}
          value={value}
        >
          {options.map((item) => (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>
        <span className="mobile-select-inner-label">{currLabel}</span>
        <div className="mobile-select-arrow-wrap">
          <span className="arrow-outline-down"></span>
        </div>
      </div>
      {/* 好像手机都有自带样式，还挺好看，不用自己写了 */}
      {/* <Drawer visible={visible} onClose={() => setVisible(false)} position="bottom">
        测试
      </Drawer> */}
    </>
  );
};
